import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=45c2c5f1&scoped=true&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2c5f1",
  null
  
)

export default component.exports